import React from 'react'
import PropTypes from 'prop-types'
import {datadogRum} from '@datadog/browser-rum'
import pkg from '../../package.json'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {hasError: false}
  }

  static getDerivedStateFromError() {
    return {hasError: true}
  }

  componentDidCatch(error, errorInfo) {
    // Get team context from DataDog RUM global context (set by DataDogRouteWrapper)
    const globalContext = datadogRum.getGlobalContext() || {};
    const team = globalContext.team || 'unknown';

    datadogRum.addError(error, {
      Version: pkg.version,
      errorInfo,
      team,
    })
  }

  render() {
    const {children} = this.props

    if (this.state.hasError) {
      return (
        <section className="hero is-fullheight" id="error-boundary-section">
          <div className="hero-body">
            <div className="container tw:text-center">
              <div className="columns is-tablet is-centered">
                <div className="column is-three-quarters">
                  <h1 className="title is-3">Aaaah! Something went wrong</h1>
                  <h6 className="subtitle is-6 tw:text-dark-gray tw:mt-1">
                    Please keep calm and press Refresh to try again :)
                  </h6>
                  <div className="control is-centered">
                    <button
                      type="submit"
                      className="button is-primary"
                      onClick={() => {
                        window.location.reload()
                      }}
                    >
                      <span className="icon is-left">
                        <i className="fa-solid fa-sync" />
                      </span>
                      <span>Refresh</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )
    }

    return children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ErrorBoundary
